import HolrMediaUsersListTable from './HolrMediaUsersListTable';

export default HolrMediaUsersListTable;
